// DemoAnimaciones.jsx
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const animaciones = {
  slideUp: {
    initial: { y: "100%", opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: "100%", opacity: 0 }
  },
  slideDown: {
    initial: { y: "-100%", opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: "-100%", opacity: 0 }
  },
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  },
  zoomIn: {
    initial: { scale: 0.8, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.8, opacity: 0 }
  },
  slideLeft: {
    initial: { x: "100%", opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: "-100%", opacity: 0 }
  },
  rotateY: {
    initial: { rotateY: 90, opacity: 0 },
    animate: { rotateY: 0, opacity: 1 },
    exit: { rotateY: 90, opacity: 0 }
  }
};

const DemoAnimaciones = () => {
  const [tipo, setTipo] = useState("slideUp");

  return (
    <div style={{ padding: 20 }}>
      <h2>Animaciones Framer Motion</h2>
      <div style={{ marginBottom: 20 }}>
        {Object.keys(animaciones).map((nombre) => (
          <button
            key={nombre}
            onClick={() => setTipo(nombre)}
            style={{
              marginRight: 10,
              marginBottom: 10,
              padding: "6px 12px",
              cursor: "pointer",
              backgroundColor: tipo === nombre ? "#222" : "#ccc",
              color: tipo === nombre ? "#fff" : "#000",
              border: "none",
              borderRadius: "4px"
            }}
          >
            {nombre}
          </button>
        ))}
      </div>

      <div style={{ position: "relative", height: 200 }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={tipo}
            initial={animaciones[tipo].initial}
            animate={animaciones[tipo].animate}
            exit={animaciones[tipo].exit}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background: "#4a90e2",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "10px",
              fontSize: "20px",
              backfaceVisibility: "hidden"
            }}
          >
            {tipo}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default DemoAnimaciones;
